import { ApplicationInsights } from '@microsoft/applicationinsights-web';

let instance: ApplicationInsights | null | undefined;

/**
 * Initializes Application Insights when `REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING` is set.
 * Safe to call multiple times.
 */
export function initApplicationInsights(): ApplicationInsights | null {
  if (instance !== undefined) {
    return instance;
  }
  const connectionString =
    process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING?.trim();
  if (!connectionString) {
    instance = null;
    return null;
  }
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
    },
  });
  appInsights.loadAppInsights();
  instance = appInsights;
  return appInsights;
}

export function getApplicationInsights(): ApplicationInsights | null {
  if (instance === undefined) {
    return initApplicationInsights();
  }
  return instance;
}

export function trackException(
  error: Error,
  customProperties?: Record<string, string>
): void {
  const ai = getApplicationInsights();
  if (!ai) {
    return;
  }
  if (customProperties) {
    ai.trackException({ exception: error }, customProperties);
  } else {
    ai.trackException({ exception: error });
  }
}

export function trackExceptionFromUnknown(
  error: unknown,
  customProperties?: Record<string, string>
): void {
  if (error instanceof Error) {
    trackException(error, customProperties);
    return;
  }
  trackException(new Error(String(error)), customProperties);
}
